import { Auth0Provider } from '@auth0/auth0-react'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import { useToggle } from '@sjblurton/use-toggle'
import type { AppProps } from 'next/app'
import { ReactNode } from 'react'
import { Navbar } from '../components'
import InputContextProvider from '../context/inputsContext'
import { AbilityContext } from '../lib/can'
import { useAbility } from '../lib/hooks/api'
import GlobalStyle from '../styles/global'
import CustomThemeProvider from '../styles/theme'

const AbilityComponent = ({ children }: { children: ReactNode }) => {
  const { ability } = useAbility()

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  )
}

function MyApp({ Component, pageProps }: AppProps) {
  LicenseInfo.setLicenseKey(
    '569f078404006dc34e94b620f8573a86T1JERVI6MzIxNTUsRVhQSVJZPTE2Njc4NTg2NTkwMDAsS0VZVkVSU0lPTj0x',
  )

  const [openToggle, setToggleOpen] = useToggle(false)

  return (
    <>
      <GlobalStyle />
      <Auth0Provider
        domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string}
        clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string}
        redirectUri={
          (typeof window !== 'undefined' && window.location.origin) || ''
        }
        useRefreshTokens={true}
        audience={process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string}
      >
        <AbilityComponent>
          <InputContextProvider>
            <CustomThemeProvider>
              <Navbar setToggleOpen={setToggleOpen} openToggle={openToggle}>
                <Component {...pageProps} />
              </Navbar>
            </CustomThemeProvider>
          </InputContextProvider>
        </AbilityComponent>
      </Auth0Provider>
    </>
  )
}

export default MyApp
